document.addEventListener('DOMContentLoaded', () => {
  const contactCustomerTrigger = document.querySelector('.js-open-contact-modal');
  
  if (!contactCustomerTrigger) return;

  const contactCustomer = document.querySelector('.contact-customer');

  if (!contactCustomer) return;

  const contactCustomerModal = contactCustomer.querySelector('.contact-customer-modal');
  const contactCustomerClose = contactCustomerModal.querySelector('.contact-customer-close');
  const chatUsBtn = contactCustomerModal.querySelector('.js-chat-us');
  const bookAppointmentBtn = contactCustomerModal.querySelector('.js-book-appointment');

  contactCustomerTrigger.addEventListener('click', toggleContactCustomer);
  contactCustomer.addEventListener('click', toggleContactCustomer);
  contactCustomerClose.addEventListener('click', toggleContactCustomer);
  contactCustomerModal.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  function toggleContactCustomer () {
    contactCustomer.classList.toggle('active');
  }

  chatUsBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const chatURL = `${window.location.origin}${window.location.pathname}?chat`;
    window.location.href = chatURL;
  });

  bookAppointmentBtn.addEventListener('click', (e) => {
    e.preventDefault();
    
    const bookAppointmentsTrgger = document.querySelector('#calendly-button-app-embed');

    if (!bookAppointmentsTrgger) return;

    bookAppointmentsTrgger.click();
  });
});